import { MoovDefinitionDTO } from "../DTO/moovDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateMoovDefinitionRequest extends BasicRequest{
   
    public moovDefinition! : MoovDefinitionDTO;
    
    constructor(){
        super()
    }
}